<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" class="row-space" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row-start">
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>
            
            <div class="form-item-rangedata"><DateRangeSelect :labelPeriodo="'Requisições'" v-model="dateRange" /></div>
            <div class="form-item-char40"><GabineteAgendaStatusSelect :ckAddTodos="true" v-model:opcaoSelecionada="idStatus" /></div>
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import GabineteAgendaStatusSelect from '@/selects/estaticos/GabineteAgendaStatusSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idStatus = ref(0);
const isLoading = ref(false);


const lsOpcoes = ref([
    {id: 'gabAgendaLista', descricao: 'Listagem geral'},
]);
const opcaoSelecionada = ref('gabAgendaLista');

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intp1: idStatus.value,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>